import { AuthenticationDetails, CognitoUser, CognitoUserAttribute, CognitoUserPool } from 'amazon-cognito-identity-js'

if (typeof global === 'undefined') {
  window.global = window;
}


const userPoolId = process.env.REACT_APP_USER_POOL_ID;
const clientId = process.env.REACT_APP_WEB_CLIENT_ID;
const poolData = {
  UserPoolId: `${userPoolId}`,
  ClientId: `${clientId}`,
}

const userPool = new CognitoUserPool(poolData)

let currentUser = userPool.getCurrentUser()

export const getCurrentUser=()=> {
  return currentUser
}

const getCognitoUser=(username)=> {
  const userData = {
    Username: username,
    Pool: userPool,
  }
  const cognitoUser = new CognitoUser(userData)

  return cognitoUser
}

export const getSession = async () => {
  if (!currentUser) {
    currentUser = userPool.getCurrentUser();
  }

  if (!currentUser) {
      throw new Error("No current user found in the session");
  }

  return new Promise((resolve, reject) => {
      
      // Add a timeout to prevent hanging
      const timeoutId = setTimeout(() => {
          reject(new Error("Session request timed out after 10 seconds"));
      }, 10000);

      currentUser.getSession((err, session) => {
          // Clear the timeout since we got a response
          clearTimeout(timeoutId);
          
          if (err) {
              reject(err);
          } else {
              resolve(session);
          }
      });
  });
}

export  const signUpUserWithEmail = async({email, password})=> {
  return new Promise( (resolve, reject)=>{
    const attributeList = ([]);
    const emailAttribute = new CognitoUserAttribute({
      Name: 'email',
      Value: email,
    });

    // const phoneNumberAttribute = new CognitoUserAttribute({
    //   Name: 'phone_number',
    //   Value: phoneNumber,
    // });

    // const fullNameAttribue = new CognitoUserAttribute({
    //   Name: 'custom:full_name',
    //   Value: fullName,
    // });

    attributeList.push(emailAttribute);
    // attributeList.push(phoneNumberAttribute);
    // attributeList.push(fullNameAttribue);

    userPool.signUp(
      email,
      password,
      attributeList,
      null,
      (err, result) => {
          if (err) {
              reject(err);
          } else {
              resolve(result);
          }
      }
  );
  }).catch((err) => {
    throw err
  })
}

export const  setAttribute = async(attribute)=> {
  return new Promise( (resolve, reject)=> {
    const attributeList = []
    const res = new CognitoUserAttribute(attribute)
    attributeList.push(res)

    currentUser?.updateAttributes(attributeList, (err, res) => {
      if (err) {
        reject(err)
      } else {
        resolve(res)
      }
    })
  }).catch((err) => {
    throw err
  })
}

export const verifyCode = async(username, code)=> {
  return new Promise( (resolve, reject)=> {
    const cognitoUser = getCognitoUser(username)

    cognitoUser.confirmRegistration(code, true,  (err, result)=> {
      if (err) {
        reject(err)
      } else {
        resolve(result)
      }
    })
  }).catch((err) => {
    throw err
  })
}

export const  signInWithEmail = async(username, password)=> {
  return new Promise( (resolve, reject)=> {
    const authenticationData = {
      Username: username,
      Password: password,
    }
    const authenticationDetails = new AuthenticationDetails(authenticationData)

    currentUser = getCognitoUser(username)
    currentUser.authenticateUser(authenticationDetails, {
      onSuccess:  (result)=> {
        resolve({
          accessToken: result.getAccessToken().getJwtToken(),
          idToken: result.getIdToken().getJwtToken(),
          refreshToken: result.getRefreshToken().getToken()
        })
      },
      onFailure:  (err)=> {
        reject(err)
      },
    })
  }).catch((err) => {
    throw err
  })
}

export const signOut=()=>{
  if (currentUser) {
    currentUser.signOut()
  }
}

export const getAttributes= async()=> {
  return new Promise( (resolve, reject)=> {
    currentUser?.getUserAttributes( (err, attributes) =>{
      if (err) {
        reject(err)
      } else {
        resolve(attributes)
      }
    })
  }).catch((err) => {
    throw err
  })
}

export const sendCode = async(username) =>  {
  return new Promise( (resolve, reject)=> {
    const cognitoUser = getCognitoUser(username)

    if (!cognitoUser) {
      reject(`could not find ${username}`)
      return
    }

    cognitoUser.forgotPassword({
      onSuccess:  (res)=> {
        resolve(res)
      },
      onFailure:  (err)=> {
        reject(err)
      },
    })
  })
}

export const forgotPassword = async(username, code, password) =>  {
  return new Promise( (resolve, reject)=> {
    const cognitoUser = getCognitoUser(username)

    if (!cognitoUser) {
      reject(`could not find ${username}`)
      return
    }

    cognitoUser.confirmPassword(code, password, {
      onSuccess: () =>{
        resolve('password updated')
      },
      onFailure: (err)=> {
        reject(err)
      },
    })
  })
}

export const changePassword = async(oldPassword, newPassword) =>  {
  return new Promise( (resolve, reject)=> {
    currentUser?.changePassword(oldPassword, newPassword,  (err, res)=> {
      if (err) {
        reject(err)
      } else {
        resolve(res)
      }
    })
  })
}

export const resendOtpCode = async(username) =>  {
  return new Promise( (resolve, reject)=> {
    const cognitoUser = getCognitoUser(username)
    if (!cognitoUser) {
      reject(`could not find ${username}`)
      return
    }
    
    cognitoUser.resendConfirmationCode( (err, result)=> {
      if (err) {
        reject(err);
        return;
      } else {
        resolve(result);
      }
    })
  })
}

export const changePasswordNew = async(username, oldPassword, newPassword) =>  {
  return new Promise((resolve, reject)=> {
    const cognitoUser = getCognitoUser(username)

    const authenticationData = {
      Username: username,
      Password: oldPassword,
    }
 
    const authenticationDetails = new AuthenticationDetails(authenticationData);
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: async(session) => {
        await new Promise((changeResolve, changeReject) => {
          cognitoUser.changePassword(oldPassword, newPassword, (err, result) => {
            if (err) {
              changeReject(new Error(`Failed to change password: ${err.message || JSON.stringify(err)}`));
              return;
            }
            changeResolve(result);
          });
        });
        
        resolve({
          status: 'SUCCESS',
          message: 'Password changed successfully',
          session
        });
      },
      onFailure: (err) => {
        reject(new Error(`Authentication failed: ${err.message || JSON.stringify(err)}`));
      },
      newPasswordRequired: (userAttributes, requiredAttributes) => {
        cognitoUser.completeNewPasswordChallenge(
          newPassword,
          {},
          {
            onSuccess: (session) => {
              resolve({
                status: 'SUCCESS',
                message: 'New password challenge completed successfully',
                session
              });
            },
            onFailure: (err) => {
              reject(new Error(`Failed to complete new password challenge: ${err.message || JSON.stringify(err)}`));
            }
          }
        );
      },
    })
  })
}